var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6C1 3.23858 3.23858 1 6 1H36C38.7614 1 41 3.23858 41 6V36C41 38.7614 38.7614 41 36 41H6C3.23858 41 1 38.7614 1 36V6Z",
    fill: "#001B53",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11C21.55 11 22 11.45 22 12V16H28.5C29.33 16 30 16.67 30 17.5C30 18.33 29.33 19 28.5 19H22V23H25.5C26.33 23 27 23.67 27 24.5C27 25.33 26.33 26 25.5 26H22V30C22 30.55 21.55 31 21 31C20.45 31 20 30.55 20 30V26H16.5C15.67 26 15 25.33 15 24.5C15 23.67 15.67 23 16.5 23H20V19H13.5C12.67 19 12 18.33 12 17.5C12 16.67 12.67 16 13.5 16H20V12C20 11.45 20.45 11 21 11Z",
    fill: "#9297A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5H36V0.5H6V1.5ZM40.5 6V36H41.5V6H40.5ZM36 40.5H6V41.5H36V40.5ZM1.5 36V6H0.5V36H1.5ZM6 40.5C3.51472 40.5 1.5 38.4853 1.5 36H0.5C0.5 39.0376 2.96243 41.5 6 41.5V40.5ZM40.5 36C40.5 38.4853 38.4853 40.5 36 40.5V41.5C39.0376 41.5 41.5 39.0376 41.5 36H40.5ZM36 1.5C38.4853 1.5 40.5 3.51472 40.5 6H41.5C41.5 2.96243 39.0376 0.5 36 0.5V1.5ZM6 0.5C2.96243 0.5 0.5 2.96243 0.5 6H1.5C1.5 3.51472 3.51472 1.5 6 1.5V0.5Z",
    fill: "#D0D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/alignCenter.d2dc3cad8cbce234b431d8f1cf8382a6.svg";
export { ForwardRef as ReactComponent };